export const locales = [
  'en',
  'pt',
  'es',
  'zh',
  'ja',
  'fr',
  'de',
  'ru',
  'id',
  'hi',
  'ko',
  'pl',
  'tr',
  'vi',
  'fi',
  'ar',
]
